import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import IOText from "../../ReUableComponents/ImageOntext";
import PBanner from "../../Assessts/Images/Gallary/Publications/PBanner.png";

import N1 from "../../Assessts/Images/Gallary/Publications/NewsLetters/Vidya Setu - Edition 1 June.png";
import N2 from "../../Assessts/Images/Gallary/Publications/NewsLetters/Vidya Setu - Edition 2  July.png";
import N3 from "../../Assessts/Images/Gallary/Publications/NewsLetters/Vidya Setu - Edition 3 August.png";
import N4 from "../../Assessts/Images/Gallary/Publications/NewsLetters/Vidya Setu - Edition 4 September.png";
import N5 from "../../Assessts/Images/Gallary/Publications/NewsLetters/Vidya Setu - Edition 5 October.png";
import N6 from "../../Assessts/Images/Gallary/Publications/NewsLetters/Vidya Setu - Edition 6 November.png";
import N7 from "../../Assessts/Images/Gallary/Publications/NewsLetters/VidyaSetu - Edition 7 December.png";
import N8 from "../../Assessts/Images/Gallary/Publications/NewsLetters/VidyaSetu - Edition 8 January.png";
import N9 from "../../Assessts/Images/Gallary/Publications/NewsLetters/VidyaSetu - Edition 9 February.png";
import N10 from "../../Assessts/Images/Gallary/Publications/NewsLetters/VidyaSetu - Edition 10 March.png";

import TP1 from "../../Assessts/Images/Gallary/Publications/TrainingProgram/NSF-India_Vidya Pragati Oct-Dec 2025.png";
import TP2 from "../../Assessts/Images/Gallary/Publications/TrainingProgram/Skill Development Report.png";

import MC1 from "../../Assessts/Images/Gallary/Publications/MediaCoverage/Bharat News 30-03-2026.jpeg";
import MC2 from "../../Assessts/Images/Gallary/Publications/MediaCoverage/Enadu 30-03-2026.jpeg";
import MC3 from "../../Assessts/Images/Gallary/Publications/MediaCoverage/Lakshyam 01-04-2026.jpeg";
import MC4 from "../../Assessts/Images/Gallary/Publications/MediaCoverage/Manam 30-03-2026.jpeg";
import MC5 from "../../Assessts/Images/Gallary/Publications/MediaCoverage/Palle Kranthi 01-04-2026.jpeg";
import MC6 from "../../Assessts/Images/Gallary/Publications/MediaCoverage/Palle Kranthi Paper 29-03-2026.jpeg";
import MC7 from "../../Assessts/Images/Gallary/Publications/MediaCoverage/Times 01-04-2026.jpeg";
import MC8 from "../../Assessts/Images/Gallary/Publications/MediaCoverage/TimesNews 30-03-2026.jpeg";
import MC9 from "../../Assessts/Images/Gallary/Publications/MediaCoverage/Vartha Prabha 01-04-2026.jpeg";
import MC10 from "../../Assessts/Images/Gallary/Publications/MediaCoverage/Vishalandhra 01-04-2026.jpeg";
import MC11 from "../../Assessts/Images/Gallary/Publications/MediaCoverage/Vishalandhra 29-03-2026.jpeg";
import MC12 from "../../Assessts/Images/Gallary/Publications/MediaCoverage/MC12.jpg";
import MC13 from "../../Assessts/Images/Gallary/Publications/MediaCoverage/MC13.jpg";
import MC14 from "../../Assessts/Images/Gallary/Publications/MediaCoverage/MC14.jpg";
import MC15 from "../../Assessts/Images/Gallary/Publications/MediaCoverage/MC15.jpg";
import MC16 from "../../Assessts/Images/Gallary/Publications/MediaCoverage/MC16.jpg";
import MC17 from "../../Assessts/Images/Gallary/Publications/MediaCoverage/MC17.jpg";
import MC18 from "../../Assessts/Images/Gallary/Publications/MediaCoverage/MC18.png";
import MC19 from "../../Assessts/Images/Gallary/Publications/MediaCoverage/MC19.jpg";

import B1 from "../../Assessts/Images/Gallary/Publications/B1.png";
import B2 from "../../Assessts/Images/Gallary/Publications/B2.jpg";
import { FaArrowRight } from "react-icons/fa6";
import { FaArrowLeft } from "react-icons/fa6";
import { click } from "@testing-library/user-event/dist/click";
const Publications = () => {
  const NewsLetters = [
    {
      img: N1,
      ITittle: "Vidya Setu June Newsletter",
      click: () =>
        window.open(
          "./publication/Newsletters/Vidya Setu - Edition 1 June Newsletter.pdf",
          "_blank",
        ),
    },
    {
      img: N2,
      ITittle: "Vidya Setu July Newsletter",
      click: () =>
        window.open(
          "./publication/Newsletters/Vidya Setu - Edition 2  July Newsletter.pdf",
          "_blank",
        ),
    },
    {
      img: N3,
      ITittle: "Vidya Setu August Newsletter",
      click: () =>
        window.open(
          "./publication/Newsletters/Vidya Setu - Edition 3 August Newsletter.pdf",
          "_blank",
        ),
    },
    {
      img: N4,
      ITittle: "Vidya Setu September Newsletter",
      click: () =>
        window.open(
          "./publication/Newsletters/Vidya Setu - Edition 4 September Newsletter.pdf",
          "_blank",
        ),
    },
    {
      img: N5,
      ITittle: "Vidya Setu October Newsletter",
      click: () =>
        window.open(
          "./publication/Newsletters/Vidya Setu - Edition 5 October Newsletter.pdf",
          "_blank",
        ),
    },
    {
      img: N6,
      ITittle: "Vidya Setu November Newsletter",
      click: () =>
        window.open(
          "./publication/Newsletters/Vidya Setu - Edition 6 November Newsletter.pdf",
          "_blank",
        ),
    },
    {
      img: N7,
      ITittle: "Vidya Setu December Newsletter",
      click: () =>
        window.open(
          "./publication/Newsletters/Vidya Setu - Edition 7 December Newsletter.pdf",
          "_blank",
        ),
    },
    {
      img: N8,
      ITittle: "Vidya Setu January Newsletter",
      click: () =>
        window.open(
          "./publication/Newsletters/Vidya Setu - Edition 8 January Newsletter.pdf",
          "_blank",
        ),
    },
    {
      img: N9,
      ITittle: "Vidya Setu February Newsletter",
      click: () =>
        window.open(
          "./publication/Newsletters/Vidya Setu - Edition 9 February Newsletter.pdf",
          "_blank",
        ),
    },
    {
      img: N10,
      ITittle: "Vidya Setu March Newsletter",
      click: () =>
        window.open(
          "./publication/Newsletters/Vidya Setu - Edition 10 March Newsletter.pdf",
          "_blank",
        ),
    },
  ];
  const TrainingPrograms = [
    {
      img: TP1,
      ITittle: "Vidya Pragati Training Program Report",
      click: () =>
        window.open(
          "./publication/Training Reports/NSF-India_Vidya Pragati Oct-Dec 2025-26.pdf",
          "_blank",
        ),
    },
    {
      img: TP2,
      ITittle: "Skill Development Training Program Report",
      click: () =>
        window.open(
          "./publication/Training Reports/Skill Development Report.pdf",
          "_blank",
        ),
    },
  ];
  const MediaCoverage = [
    {
      img: MC1,
      ITittle: "Bharat News 30-03-2026",
      click: () =>
        window.open(
          "./publication/Media Coverage/Bharat News 30-03-2026.jpeg",
          "_blank",
        ),
    },
    {
      img: MC2,
      ITittle: "Enadu 30-03-2026",
      click: () =>
        window.open(
          "./publication/Media Coverage/Enadu 30-03-2026.jpeg",
          "_blank",
        ),
    },
    {
      img: MC3,
      ITittle: "Lakshyam 01-04-2026",
      click: () =>
        window.open(
          "./publication/Media Coverage/Lakshyam 01-04-2026.jpeg",
          "_blank",
        ),
    },
    {
      img: MC4,
      ITittle: "Manam 30-03-2026",
      click: () =>
        window.open(
          "./publication/Media Coverage/Manam 30-03-2026.jpeg",
          "_blank",
        ),
    },
    {
      img: MC5,
      ITittle: "Palle Kranthi 01-04-2026",
      click: () =>
        window.open(
          "./publication/Media Coverage/Palle Kranthi 01-04-2026.jpeg",
          "_blank",
        ),
    },
    {
      img: MC6,
      ITittle: "Palle Kranthi Paper 29-03-2026",
      click: () =>
        window.open(
          "./publication/Media Coverage/Palle Kranthi Paper 29-03-2026.jpeg",
          "_blank",
        ),
    },
    {
      img: MC7,
      ITittle: "Times 01-04-2026",
      click: () =>
        window.open(
          "./publication/Media Coverage/Times 01-04-2026.jpeg",
          "_blank",
        ),
    },
    {
      img: MC8,
      ITittle: "TimesNews 30-03-2026",
      click: () =>
        window.open(
          "./publication/Media Coverage/TimesNews 30-03-2026.jpeg",
          "_blank",
        ),
    },
    {
      img: MC9,
      ITittle: "Vartha Prabha 01-04-2026",
      click: () =>
        window.open(
          "./publication/Media Coverage/Vartha Prabha 01-04-2026.jpeg",
          "_blank",
        ),
    },
    {
      img: MC10,
      ITittle: "Vishalandhra 01-04-2026",
      click: () =>
        window.open(
          "./publication/Media Coverage/Vishalandhra 01-04-2026.jpeg",
          "_blank",
        ),
    },
    {
      img: MC11,
      ITittle: "Vishalandhra 29-03-2026",
      click: () =>
        window.open(
          "./publication/Media Coverage/Vishalandhra 29-03-2026.jpeg",
          "_blank",
        ),
    },
    {
      img: MC12,
      ITittle: "Lakshyam",
      click: () => window.open(MC12, "_blank"),
    },
    { img: MC13, ITittle: "", click: () => window.open(MC13, "_blank") },
    { img: MC14, ITittle: "", click: () => window.open(MC14, "_blank") },
    {
      img: MC15,
      ITittle: "Andhrajyothy",
      click: () => window.open(MC15, "_blank"),
    },
    { img: MC16, ITittle: "", click: () => window.open(MC16, "_blank") },
    { img: MC17, ITittle: "", click: () => window.open(MC17, "_blank") },
    { img: MC18, ITittle: "", click: () => window.open(MC18, "_blank") },
    { img: MC19, ITittle: "", click: () => window.open(MC19, "_blank") },
  ];

  const Brouchers = [
    {
      img: B1,
      ITittle: "NSF Scholarship Program Flyer",
      click: () => window.open(B1, "_blank"),
    },
    { img: B2, ITittle: "", click: () => window.open(B2, "_blank") },
  ];

  const Pdata = [
    { Data: NewsLetters, Tittle: "Publications", SubTittle: "Newsletters" },
    {
      Data: TrainingPrograms,
      Tittle: "Publications",
      SubTittle: "Training Reports",
    },
    { Data: MediaCoverage, SubTittle: "Media Coverage" },
    { Data: Brouchers, SubTittle: "Brouchers" },
  ];

  const [currentIndex, setCurrentIndex] = useState(Pdata.map(() => 0));

  const handleNext = (sectionIndex, length) => {
    setCurrentIndex((prev) => {
      const updated = [...prev];
      updated[sectionIndex] = (updated[sectionIndex] + 1) % length;
      return updated;
    });
  };
  const handlePrev = (sectionIndex, length) => {
    setCurrentIndex((prev) => {
      const updated = [...prev];
      updated[sectionIndex] = (updated[sectionIndex] - 1 + length) % length;
      return updated;
    });
  };

  return (
    <div className="m-4">
      <div className="Single_Banner mt-2 mb-4">
        <IOText
          Image={PBanner}
          Alt="EMpower"
          Text={
            <div className="Text-MainDiv w-100">
              <div>
                Official{" "}
                <span style={{ color: "#F7D670" }}>
                  Publications Showcasing Scholarship Programs
                </span>{" "}
                and Academic Impact.
              </div>
            </div>
          }
        />
      </div>
      <div className="SEngagement">
        <div style={{ gridTemplateColumns: "1fr 1fr 1fr", display: "grid" }}>
          {Pdata.map((item, sectionIndex) => {
            const currentItem = item.Data[currentIndex?.[sectionIndex] || 0];
            return (
              <div
                key={sectionIndex}
                className="dflex flexd-column alignitems mt-3"
              >
                <div className="Web-SubHeading"> {item.SubTittle} </div>

                <div style={{ backgroundColor: "#EFFFFB" }}>
                  <div className="dflex flexd-column alignitems p-2">
                    <img
                      src={currentItem?.img}
                      alt="sample"
                      className="CPointer"
                      style={{ width: "400px", height: "200px" }}
                      onClick={currentItem?.click}
                    />
                    <p style={{ color: "#347462", fontWeight: "700" }}>
                      {" "}
                      {currentItem?.ITittle}{" "}
                    </p>
                  </div>
                  {item.Data?.length > 1 && (
                    <div className="dflex JSBetween p-3 PArrows">
                      <FaArrowLeft
                        onClick={() =>
                          handlePrev(sectionIndex, item.Data.length)
                        }
                      />
                      <FaArrowRight
                        onClick={() =>
                          handleNext(sectionIndex, item.Data.length)
                        }
                      />
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/** <div className="SEngagement">
                <div >
                    <div className="dflex flexd-column alignitems mt-3">
                        <div className="Web-SubHeading"> Brochures </div>

                        <div style={{ backgroundColor: "#EFFFFB" }}>
                            <div className="dflex flexd-column alignitems p-2">
                                <img src={B1} alt="sample" className="CPointer" onClick={()=> window.open("./publication/NSF Scholarship Program Flyer.jpg", "_blank")}/>
                                <p style={{ color: "#347462", fontWeight: "700" }}> NSF Scholarship Program Flyer </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>*/}
    </div>
  );
};
export default Publications;
